import React, { useState, useRef } from 'react';
import { PlayIcon, PauseIcon, StarIcon } from 'lucide-react';
export function AudioTestimonial() {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);
  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  const handleEnded = () => {
    setIsPlaying(false);
  };
  return <div className="bg-midnight-lighter border border-rosegold/30 rounded-2xl p-6 md:p-10 shadow-[0_0_30px_rgba(201,169,110,0.1)] relative overflow-hidden max-w-3xl mx-auto mb-20" data-id="element-12">
      {/* Background glow */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-rosegold to-transparent opacity-50" data-id="element-13" />

      <div className="flex flex-col items-center text-center" data-id="element-14">
        <div className="inline-flex items-center px-3 py-1 rounded-full bg-rosegold/10 text-rosegold text-xs font-inter font-semibold mb-6" data-id="element-15">
          🎙️ Most Powerful Testimonial — Listen
        </div>

        <div className="flex items-center mb-6" data-id="element-16">
          <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&q=80" alt="Jennifer K." className="w-16 h-16 rounded-full object-cover border-2 border-rosegold/50 mr-4" data-id="element-17" />
          <div className="text-left" data-id="element-18">
            <h4 className="font-playfair text-xl font-bold text-warmwhite" data-id="element-19">
              Jennifer K. — Dallas, TX
            </h4>
            <div className="flex text-rosegold mt-1" data-id="element-20">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-21" />)}
            </div>
          </div>
        </div>

        {/* Audio Player UI */}
        <div className="w-full bg-midnight/50 rounded-xl p-3 md:p-4 flex items-center mb-6 overflow-hidden" data-id="element-22">
          <button onClick={togglePlay} className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-rosegold text-midnight flex items-center justify-center shrink-0 hover:bg-rosegold-light transition-colors relative group" aria-label={isPlaying ? 'Pause audio' : 'Play audio'} data-id="element-23">
            {/* Ripple effect */}
            {!isPlaying && <div className="absolute inset-0 rounded-full border-2 border-rosegold animate-ripple pointer-events-none" data-id="element-24" />}
            {isPlaying ? <PauseIcon className="w-5 h-5 md:w-6 md:h-6 fill-current" data-id="element-25" /> : <PlayIcon className="w-5 h-5 md:w-6 md:h-6 fill-current ml-1" data-id="element-26" />}
          </button>

          <div className="flex-grow mx-3 md:mx-4 flex items-center h-8 gap-1 opacity-70 overflow-hidden" data-id="element-27">
            {/* Fake waveform */}
            {[...Array(30)].map((_, i) => {
            const height = 20 + Math.random() * 80;
            return <div key={i} className={`w-1 md:w-1.5 rounded-full shrink-0 ${isPlaying ? 'bg-rosegold animate-pulse' : 'bg-softgray'}`} style={{
              height: `${height}%`,
              animationDelay: isPlaying ? `${Math.random() * 0.5}s` : '0s'
            }} data-id="element-28" />;
          })}
          </div>

          <div className="text-softgray font-inter text-xs md:text-sm font-medium shrink-0" data-id="element-29">
            {isPlaying ? 'Playing...' : '1:50'}
          </div>
        </div>

        <p className="font-playfair text-xl md:text-2xl text-warmwhite italic" data-id="element-30">
          "I don't even know how to describe it... I just know I'm not the same
          person I was three weeks ago."
        </p>

        {/* Hidden audio element playing the video's audio track */}
        <audio ref={audioRef} src="https://cdn.magicpatterns.com/uploads/jeEV4yaYxxntyzaLvbRMWS/202603201554.mp4" onEnded={handleEnded} className="hidden" data-id="element-31" />
      </div>
    </div>;
}